<section>
  <h1>Manage Duplicates</h1>
  <ness-merge-people-container></ness-merge-people-container>
</section>
